import React, { useContext, useCallback, useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async';
import classNames from "classnames";
import { ResponsiveSize, ValidationState } from 'acma-spa/dist/Types';
import { reactSelectStyles } from 'acma-spa/dist/pickers/PickerStyles';
import { GroupContext, LabelContext } from 'acma-spa';
import styles from "acma-spa/dist/pickers/PickerStyles.scss";
import { ClientApiProps } from './ClientApiProps';
import { IFilter } from '../api';

export interface FilterPickerProps {
  /**
   * Control id
   */
  id?: string;

  /**
   * Control value
   */
  value: IFilter[];

  /**
   * Trigger OnChnage
   */
  onChange: (v: IFilter[]) => void;

  /**
   * Control size
   */
  size?: ResponsiveSize;

  /**
   * Control state
   */
  state?: ValidationState;

  /**
   * Trigger disabled
   */
  disabled?: boolean;

  /**
   * Custom class name
   */
  className?: string;

  /**
   * Options
   */
  getOptions: (s: string) => Promise<IFilter[]>
  defaultOptions?: IFilter[]
}

export const FilterPicker: React.FC<FilterPickerProps> = ({ size = 'block', ...props }) => {

  const labelCtx = useContext(LabelContext);
  const groupCtx = useContext(GroupContext);
  const state = labelCtx.state || props.state;

  const getOptions = async (s: string) => {
    var res = await props.getOptions(s);
    if (s) {
      res.splice(0, 0, {
        label: `Name containing "${s}"`,
        value: s
      })
    }
    return res;
  }

  return <div className={classNames(styles["au-picker"], {
    [styles[`au-picker--width-${size}`]]: size && size != 'block',
    [styles[`au-picker--block`]]: size == 'block'
  }, groupCtx.className, props.className)}>
    <AsyncSelect<IFilter, true>
      isMulti={true}
      inputId={props.id || labelCtx.id}
      styles={reactSelectStyles(state)}
      className={classNames(groupCtx.className, props.className)}
      placeholder="Search..."
      loadOptions={s => getOptions(s)}
      value={props.value}
      onChange={v => props.onChange(v.slice())}
      getOptionLabel={r => r.label ?? ""}
      getOptionValue={r => r.value ?? ""}
      isClearable
      isDisabled={props.disabled}
      cacheOptions={false}
      defaultOptions={props.defaultOptions}
    />
  </div>
}
